// extracted by mini-css-extract-plugin
export var green = "#428a13";
export var greenTint = "#69a041";
export var greenShade = "#32690f";
export var blue = "#219ad8";
export var blueTint = "#4bafe1";
export var blueShade = "#1973a0";
export var purple = "#be50c8";
export var red = "#e9501e";
export var lightGray = "#e6e6e6";
export var lightGrayTint = "#f2f2f2";
export var lightGrayShade = "#ccc";
export var gray = "#767676";
export var grayTint = "#a6a6a6";
export var grayShade = "#5a5a5a";
export var darkGray = "#414141";
export var darkGrayTint = "#676767";
export var darkGrayShade = "#191919";